/**
 * 단일 값을 trim 처리하는 함수
 * @param {string} value 처리할 값
 * @returns {string} trim된 문자열 또는 빈 문자열
 */
export function trimString(value) {
    if (value && String(value).trim()) {
        return String(value).trim();
    }
    return "";
}
/**
 * @description 배열 내 문자열의 value 속성을 trim 처리하는 함수
 *
 * @param {Array<{value: string}>} inputArray value 속성을 가진 객체 배열
 * @returns {Array<string>} trim 처리된 문자열 배열
 */
export function trimArrayStrings(inputArray) {
    return inputArray.map((input) => trimString(input));
}
/**
 * @description 객체 배열의 각 객체의 문자열 값을 trim 처리하는 함수 (depth 1)
 * @param arr
 * @returns
 */
export function trimObjectArray(arr) {
    return arr.map((obj) => {
        return Object.fromEntries(Object.entries(obj).map(([key, value]) => [
            key,
            typeof value === "string" ? value.trim() : value,
        ]));
    });
}
/**
 * @description 문자열을 정리하는 함수
 * - 양쪽 공백 제거
 * - 줄바꿈 문자 제거
 * - 여러 공백을 하나의 공백으로 변환
 * @param value 정리할 문자열
 * @returns 정리된 문자열
 */
export function sanitizeString(value) {
    return value
        .trim()
        .replace(/\r?\n|\r/g, "")
        .replace(/\s+/g, " ");
}
